import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Link from "@material-ui/icons/Link";
import CheckCircle from "@material-ui/icons/CheckCircle";

import { fetchPost, fetchGet } from "../../api/fetch";
import { calcProductState } from "./ProductUtil";
import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';
import css from "./ProductSearch.module.css";
import Add from './assets/add.svg';
import GreenCheck from './assets/check_green.svg';
import VMIList from './assets/list_icon_jrv_mobile.svg';
import MobileSearchRow from "./MobileSearchRow";

const styles = {};

const ProductSearch = (props) => {
  const { associateProduct, language, zoneBranchName } = props;

  const [componentType, setComponentType] = React.useState("")
  const [vmiId, setVmiId] = React.useState()
  const [description, setDescription] = React.useState("")
  const [manufacturerCode, setManufacturerCode] = React.useState("")
  const [manufacturer, setManufacturer] = React.useState("")
  //Product Search
  const [binCode, setBinCode] = React.useState("")
  //Product Association
  const [vendorName, setVendorName] = React.useState("")
  const [vendorCode, setVendorCode] = React.useState("")
  const [ogcCode, setOgcCode] = React.useState("")
  const [jrvCode, setJrvCode] = React.useState("")
  const [category, setCategory] = React.useState("")
  const [searchResults, setSearchResults] = React.useState([])
  // Sort
  const [sortDescription, setSortDescription] = React.useState(false)
  const [sortManufacturerCode, setSortManufacturerCode] = React.useState(false)
  const [sortManufacturer, setSortManufacturer] = React.useState(false)
  const [sortBinCode, setSortBinCode] = React.useState(false)
  const [sortVendorName, setSortVendorName] = React.useState(false)
  const [sortVendorCode, setSortVendorCode] = React.useState(false)
  const [sortOgcCode, setSortOgcCode] = React.useState(false)
  const [sortJrvCode, setSortJrvCode] = React.useState(false)
  const [sortAssigned, setSortAssigned] = React.useState(false)
  const [sortCategory, setSortCategory] = React.useState(false)
  // Fetch
  const [isFetching, setIsFetching] = React.useState(false)
  // Mobile
  const [mobileOpenSearch, setMobileOpenSearch] = React.useState(true)

  React.useEffect(() => {
    setComponentType(props.componentType)
    setVmiId(parseInt(props.vmiId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectProduct = (id, zoneId, orqId, pziId) => {
    if (orqId) {
      fetchGet(`order_request/${orqId}`) //UPDATE THIS TO FETCH SIMILAR VALUES TO ORDER REQ TABLE - ANDREW MAR25 2022
        .then(orderRequest => {
          console.log(orderRequest)
          orderRequest["order_request_id"] = orderRequest["id"]
          orderRequest["order_request_quantity"] = orderRequest["quantity"]
          orderRequest["order_request_units"] = orderRequest["unit_of_measurement"]
          props.setSelectedProductData({ id, orderRequest, zoneId, pziId })
          props.setOpenRequest(true)
        })
    } else {
      props.setSelectedProductData({ id, orderRequest: null, zoneId, pziId })
      props.setOpenRequest(true)
    }
  }

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      handleSearchProduct()
    }
  }

  const handleSearchProduct = sortParameters => {
    setSearchResults([])
    const body = {
      "description": description ? description.trim() : null,
      "code_product": vendorCode ? vendorCode.trim() : null,
      "vendor_name": vendorName ? vendorName.trim() : null,
      "manufacturer_name": manufacturer ? manufacturer.trim() : null,
      "manufacturer_code": manufacturerCode ? manufacturerCode.trim() : null,
      "ogc": ogcCode ? ogcCode.trim() : null,
      "category": category ? category.trim() : null,
      "limit": 100,
      "vmi": vmiId,
      "codebin": binCode ? parseInt(binCode.trim()) : null,
      "pzitbl": componentType === "productAssociation" ? false : true,
      "jrv_code": jrvCode ? jrvCode.trim() : null,
      "offset": 0,
      "sort": sortParameters ? sortParameters : null,
    }

    try {
      setIsFetching(true)
      fetchPost("products/search", body)
        .then(res => {
          setSearchResults(res.items)
          setIsFetching(false)
        })
        .catch(e => {
          console.error(e)
        })
    } catch (e) {
      console.log(e);
    }
  }

  const handleSort = (column, order, setStateFunction) => {

    if ((description || vendorCode || vendorName || ogcCode || manufacturerCode || manufacturer || category || binCode || jrvCode) && searchResults[0]) {

      const sortOrder = order ? "asc" : "desc";
      setStateFunction(order)
      handleSearchProduct({
        "column": column,
        "order": sortOrder,
      })
    }

  }

  const handleResetFields = () => {
    setDescription("")
    setVendorCode("")
    setVendorName("")
    setOgcCode("")
    setManufacturerCode("")
    setManufacturer("")
    setCategory("")
    setBinCode("")
    setJrvCode("")
    setSortDescription(false)
    setSortManufacturerCode(false)
    setSortManufacturer(false)
    setSortBinCode(false)
    setSortVendorName(false)
    setSortVendorCode(false)
    setSortOgcCode(false)
    setSortJrvCode(false)
    setSortCategory(false)
  }

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  return (
    getWidth() > 478 ?
      <div className={css.productSearchPopup}>
        <div className={css.scanPopupNav}>
          <div className={css.title}>{componentType === "productAssociation" ? I18n.get("associate_product") : I18n.get("add_request").toUpperCase()}</div>
          <Close className={css.closeButton} onClick={() => props.setOpenSearch(false)} />
          <div className={css.vmiName}>{componentType === "productAssociation" ? zoneBranchName : props.vmiName}</div>
        </div>
        <div className={css.searchPopupMain}>
          <div className={css.interactPanel}>
            <div className={css.controlPanel}>
              <div>{I18n.get("site_search")}</div>
            </div>
            <div className={css.searchInputDescription}>
              <div className={css.inputSubtitle}>{I18n.get("site_description")}</div>
              <TextField
                value={description}
                placeholder={I18n.get("site_description")}
                onChange={e => setDescription(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
                variant="outlined"
                InputProps={{
                  startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                  endAdornment: description ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setDescription("")}><Close /></InputAdornment> : null,
                  className: css.searchInput,
                  style: { fontSize: 14, padding: "0 0 0 8px" }
                }}
              />
            </div>
            {componentType === "productAssociation" ?
              <>
                <div className={css.inputSubtitle}>{I18n.get("jrv_code")}</div>
                <TextField
                  value={jrvCode}
                  placeholder={I18n.get("jrv_code")}
                  onChange={e => setJrvCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: jrvCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setJrvCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>
              :
              null}
            <div className={css.inputSubtitle}>{I18n.get("manufacturer_item_code")}</div>
            <TextField
              value={manufacturerCode}
              placeholder={I18n.get("manufacturer_item_code")}
              onChange={e => setManufacturerCode(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: manufacturerCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturerCode("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            <div className={css.inputSubtitle}>{I18n.get("manufacturer")}</div>
            <TextField
              value={manufacturer}
              placeholder={I18n.get("manufacturer")}
              onChange={e => setManufacturer(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: manufacturer ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturer("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            {componentType === "productAssociation" ?
              <>
                <div className={css.inputSubtitle}>{I18n.get("vendor_item_code")}</div>
                <TextField
                  value={vendorCode}
                  placeholder={I18n.get("vendor_item_code")}
                  onChange={e => setVendorCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: vendorCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setVendorCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("vendor_name")}</div>
                <TextField
                  value={vendorName}
                  placeholder={I18n.get("vendor_name")}
                  onChange={e => setVendorName(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: vendorName ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setVendorName("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("ogc_reference")}</div>
                <TextField
                  value={ogcCode}
                  placeholder={I18n.get("ogc_reference")}
                  onChange={e => setOgcCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: ogcCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setOgcCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>
              :
              <>
                <div className={css.inputSubtitle}>{I18n.get("code_bin")}</div>
                <TextField
                  value={binCode}
                  placeholder={I18n.get("code_bin")}
                  onChange={e => setBinCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: binCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setBinCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>}
            <div className={css.inputSubtitle}>{I18n.get("category")}</div>
            <TextField
              value={category}
              placeholder={I18n.get("category")}
              onChange={e => setCategory(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: category ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setCategory("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            <div className={css.btnPanel}>
              <div className={css.blueText} onClick={() => handleResetFields()}>{I18n.get("reset_fields")}</div>
              <button className={css.confirmBtn} onClick={() => handleSearchProduct()}>{!isFetching ? I18n.get("site_search").toUpperCase() : <CircularProgress size={16} style={{ 'color': 'white' }} />}</button>
            </div>
          </div>
          <div className={css.mainTable}>
            <div className={css.results}>
              {I18n.get("search_results")}: {<div className={css.grayText}>{searchResults.length}</div>}
            </div>
            <div style={{ height: 50 * searchResults.length + 50 }} className={`${css.searchResult} ${searchResults.length === 0 ? css.searchNoResults : ""}`}>
              <table className={css.productSearchTable}>
                <thead >
                  <tr className={`${css.tableHeader} ${componentType === "productAssociation" ? css.productAssociation : css.productSearch}`}>
                    <th className={css.tableAdd}>
                      {componentType !== 'productAssociation' ? <img src={VMIList} alt="VMI List" /> : null}
                    </th>
                    {componentType === "productAssociation" ?
                      <th className={css.tableAssigned}>
                        <div className={css.headerCenterSubtitle}>
                          <Link />
                          <div className={css.sortContainer} onClick={() => handleSort("assigned", !sortAssigned, setSortAssigned)}>
                            {!sortAssigned ?
                              <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> :
                              <img src={DropdownDown} alt="Sort Down Arrow" />
                            }
                          </div>
                        </div>
                      </th>
                      : null}
                    <th>
                      <div className={css.headerSubtitle}>
                        <span>{I18n.get("site_description")}</span>
                        <div className={css.sortContainer} onClick={() => handleSort("description", !sortDescription, setSortDescription)}>
                          {!sortDescription ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    {componentType === "productAssociation" ?
                      <th>
                        <div className={css.headerSubtitle}>
                          <span>{I18n.get("jrv_code")}</span>
                          <div className={css.sortContainer} onClick={() => handleSort("jrv_code", !sortJrvCode, setSortJrvCode)}>
                            {!sortJrvCode ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                          </div>
                        </div>
                      </th>
                      :
                      null
                    }
                    <th className={css.tableVendorCode}>
                      <div className={css.headerSubtitle}>
                        <span>{I18n.get("manufacturer_item_code")}</span>
                        <div className={css.sortContainer} onClick={() => handleSort("manufacturer_code", !sortManufacturerCode, setSortManufacturerCode)}>
                          {!sortManufacturerCode ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={css.tableVendorName}>
                      <div className={css.headerSubtitle}>
                        <span>{I18n.get("manufacturer")}</span>
                        <div className={css.sortContainer} onClick={() => handleSort("manufacturer_name", !sortManufacturer, setSortManufacturer)}>
                          {!sortManufacturer ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    {componentType === "productAssociation" ?
                      <>
                        <th className={css.tableVendorCode}>
                          <div className={css.headerSubtitle}>
                            <span>{I18n.get("vendor_item_code")}</span>
                            <div className={css.sortContainer} onClick={() => handleSort("code_product", !sortVendorCode, setSortVendorCode)}>
                              {!sortVendorCode ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                            </div>
                          </div>
                        </th>
                        <th className={css.tableVendorName}>
                          <div className={css.headerSubtitle}>
                            <span>{I18n.get("vendor_name")}</span>
                            <div className={css.sortContainer} onClick={() => handleSort("vendor_name", !sortVendorName, setSortVendorName)}>
                              {!sortVendorName ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                            </div>
                          </div>
                        </th>
                        <th className={css.tableOgc}>
                          <div className={css.headerSubtitle}>
                            <span>{I18n.get("ogc_reference")}</span>
                            <div className={css.sortContainer} onClick={() => handleSort("ogc", !sortOgcCode, setSortOgcCode)}>
                              {!sortOgcCode ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                            </div>
                          </div>
                        </th>
                      </>
                      :
                      null
                    }
                    <th className={css.tableCategory}>
                      <div className={css.headerSubtitle}>
                        <span>{I18n.get("category")}</span>
                        <div className={css.sortContainer} onClick={() => handleSort("category", !sortCategory, setSortCategory)}>
                          {!sortCategory ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    {componentType === "productAssociation" ?
                      <th className={css.tableState}>
                        <div className={css.headerSubtitle}>{I18n.get("product_state")}</div>
                      </th>
                      :
                      <>
                        <th className={css.tableLocation}>
                          <div className={css.headerSubtitle}>{I18n.get("location_vmi")}</div>
                        </th>
                        <th className={css.tableBinCode}>
                          <div className={css.headerSubtitle}>
                            <span>{I18n.get("code_bin")}</span>
                            <div className={css.sortContainer} onClick={() => handleSort("codebin", !sortBinCode, setSortBinCode)}>
                              {!sortBinCode ? <img src={DropdownDown} className={css.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                            </div>
                          </div>
                        </th>
                      </>
                    }
                  </tr>
                </thead>
                <tbody className={css.tbody}>
                  {searchResults.map((p, i) =>
                    <tr key={`product-${i}`} className={`${css.tableRow} ${componentType === "productAssociation" ? css.productAssociation : css.productSearch} ${(i + 1) % 2 === 0 ? css.evenRow : ""}`}>
                      <td className={css.tableAdd}>
                        {componentType === "productAssociation" ?
                          (!p.blocked && !p.deleted && !p.obsolete ?
                            <div className={css.rowAdd}
                              onClick={() => { associateProduct(p); props.setOpenSearch(false); }}
                            >
                              <Link style={{ color: '#5f00a0' }} />
                            </div> :
                            null
                          ) :
                          <div className={css.rowAdd} onClick={() => handleSelectProduct(p.product_id, p.zone_id, p.order_request_id, p.pzi_id)}>
                            <img src={p.order_request_id ? GreenCheck : Add} alt="Add Order Request" />
                          </div>}
                      </td>
                      {componentType === "productAssociation" ?
                        <td className={css.rowAssigned} title={p.assigned[0] ? p.assigned.reduce((x, y) => x + "•  " + y + "\n\n", "") : ""}>
                          {p.assigned?.length > 0 ?
                            <>
                              <CheckCircle style={{ fontSize: 16, color: '#68ac58' }} />
                              <span>{`(${p.assigned?.length})`}</span>
                            </> : null}
                        </td>
                        : null}
                      <td>
                        <div className={css.tableSubtitle} title={p.description_fr}>
                          {language === 'en' ? p.description_en : p.description_fr}
                        </div>
                      </td>
                      {componentType === "productAssociation" ?
                        <td>
                          <div className={css.tableSubtitle}>
                            {p.jrv_code}
                          </div>
                        </td>
                        :
                        null
                      }
                      <td>
                        <div className={css.tableSubtitle}>
                          {p.manufacturer_code}
                        </div>
                      </td>
                      <td>
                        <div className={`${css.tableSubtitle} ${css.cellEllipse}`} title={p.vendor_name}>
                          {p.manufacturer_name}
                        </div>
                      </td>
                      {componentType === "productAssociation" ?
                        <>
                          <td>
                            <div className={css.tableSubtitle}>
                              {p.code_product}
                            </div>
                          </td>
                          <td>
                            <div className={css.tableSubtitle} title={p.vendor_name}>
                              {p.vendor_name}
                            </div>
                          </td>
                          <td>
                            <div className={css.tableSubtitle} title={p.ogc}>
                              {p.ogc}
                            </div>
                          </td>
                        </>
                        :
                        null
                      }
                      <td>
                        <div className={`${css.tableSubtitle} ${css.cellEllipse}`} title={p.category}>
                          {p.category}
                        </div>
                      </td>
                      {componentType === "productAssociation" ?
                        <td>
                          <div className={css.tableSubtitle} title={p.state}>
                            {calcProductState(p.blocked, p.deleted, p.obsolete)}
                          </div>
                        </td>
                        :
                        <>
                          <td>
                            <div className={css.tableSubtitle} title={p.assigned[0]}>
                              {p.assigned[0] ? p.assigned[0].split(" > ").slice(1).join(" > ") : "-"}
                            </div>
                          </td>
                          <td>
                            <div className={css.tableSubtitle}>
                              {p.pzi_id}
                            </div>
                          </td>
                        </>
                      }
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      :
      <div className={`${css.mobileSearchPopup} ${mobileOpenSearch ? css.mobileSearchPopupOpen : ""}`}>
        <div className={css.mobileScanPopupNav}>
          <div className={css.searchNavControl} onClick={() => setMobileOpenSearch(!mobileOpenSearch)} >
            <img src={mobileOpenSearch ? DropdownDown : DropdownRight} alt="Dropdown Down Arrow" />
            <Search />
          </div>
          <div className={css.mobileTitle}>
            <div className={css.title}>{componentType === "productAssociation" ? I18n.get("associate_product") : I18n.get("add_request").toUpperCase()}</div>
          </div>
          <Close className={css.closeButton} onClick={() => props.setOpenSearch(false)} />
        </div>
        <div className={css.vmiName}>{componentType === "productAssociation" ? zoneBranchName : props.vmiName}</div>
        {mobileOpenSearch ?
          <div className={css.mobileSearchPanel}>
            <div className={css.inputSubtitle}>{I18n.get("site_description")}</div>
            <TextField
              value={description}
              placeholder={I18n.get("site_description")}
              onChange={e => setDescription(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: description ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setDescription("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            {componentType === "productAssociation" ?
              <>
                <div className={css.inputSubtitle}>{I18n.get("jrv_code")}</div>
                <TextField
                  value={jrvCode}
                  placeholder={I18n.get("jrv_code")}
                  onChange={e => setJrvCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: jrvCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setJrvCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>
              :
              null}
            <div className={css.inputSubtitle}>{I18n.get("manufacturer_item_code")}</div>
            <TextField
              value={manufacturerCode}
              placeholder={I18n.get("manufacturer_item_code")}
              onChange={e => setManufacturerCode(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: manufacturerCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturerCode("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            <div className={css.inputSubtitle}>{I18n.get("manufacturer")}</div>
            <TextField
              value={manufacturer}
              placeholder={I18n.get("manufacturer")}
              onChange={e => setManufacturer(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: manufacturer ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturer("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            {componentType === "productAssociation" ?
              <>
                <div className={css.inputSubtitle}>{I18n.get("vendor_item_code")}</div>
                <TextField
                  value={vendorCode}
                  placeholder={I18n.get("vendor_item_code")}
                  onChange={e => setVendorCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: vendorCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setVendorCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("vendor_name")}</div>
                <TextField
                  value={vendorName}
                  placeholder={I18n.get("vendor_name")}
                  onChange={e => setVendorName(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: vendorName ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setVendorName("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("ogc_reference")}</div>
                <TextField
                  value={ogcCode}
                  placeholder={I18n.get("ogc_reference")}
                  onChange={e => setOgcCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: ogcCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setOgcCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>
              :
              <>
                <div className={css.inputSubtitle}>{I18n.get("code_bin")}</div>
                <TextField
                  value={binCode}
                  placeholder={I18n.get("code_bin")}
                  onChange={e => setBinCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: binCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setBinCode("")}><Close /></InputAdornment> : null,
                    className: css.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </>}
            <div className={css.inputSubtitle}>{I18n.get("category")}</div>
            <TextField
              value={category}
              placeholder={I18n.get("category")}
              onChange={e => setCategory(e.target.value)}
              onKeyDown={handleKeyDown}
              variant="outlined"
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                endAdornment: category ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setCategory("")}><Close /></InputAdornment> : null,
                className: css.searchInput,
                style: { fontSize: 14, padding: "0 0 0 8px" }
              }}
            />
            <div className={css.btnPanel}>
              <div className={css.blueText} onClick={() => handleResetFields()}>{I18n.get("reset_fields")}</div>
              <button className={css.confirmBtn} onClick={() => handleSearchProduct()}>{!isFetching ? I18n.get("site_search").toUpperCase() : <CircularProgress size={16} style={{ 'color': 'white' }} />}</button>
            </div>
          </div>
          : null}
        <div className={css.mobileSearchInfo}>
          <div className={css.results}>
            {I18n.get("search_results")}: {<div className={css.grayText}>{searchResults.length}</div>}
          </div>
        </div>
        <div className={css.mobileSearchResults}>
          {searchResults.map((p, i) =>
            <MobileSearchRow key={`order-${i}-${p.pzi_id}`} product={p} handleSelectProduct={handleSelectProduct}
            />
          )}
        </div>
      </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ProductSearch))

);